export const FILE_TYPES = {
  CSV: "csv",
  XLSX: "xlsx"
};

export const LIST_TYPES = {
  PATIENTS: "patients",
  ENROLLMENTS: "enrollments",
  CLAIMS: "claims",
  SAVED_LIST: "savedList"
};

export const MAX_EXPORT_RECORDS = 2000;

export const EXCLUDED_EXPORT_COLUMNS = ["edit", "star", "hasConflicts"];
